import { RootState, useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { SEARCH_DELAY, breakpoint } from 'utility/constant';

import { LabelsBoxWithSearchType } from './utils/utils';
import { ScommesseFiltersList } from 'components/scommesseFiltersList';
import { ScommesseSearch } from 'components/scommesseSearch';
import { ScommesseTitle } from 'components/scommesseTitle';
import { Wrapper } from 'components/wrapper';
import { setTextSearchedTipiScommessa } from 'features/sport/sportSlice';
import styles from './SportBoxWithSearch.module.scss';
import { useDebounce } from 'hooks';
import { useSelector } from 'react-redux';
import { useSportSearchTipiScommessa } from 'hooks/useSportSearchTipiScommessa';
import useWindowSize from 'hooks/useWindowSize';

export type SportBoxWithSearchProps = {
  labelsBoxWithSearch: LabelsBoxWithSearchType;
  children?: React.ReactNode;
  isActive?: boolean;
  slug?: string;
  // onSecondaryFilterSelected?: Dispatch<
  //   SetStateAction<{ gruppoKey: string; value: string } | undefined>
  // >;
  noPaddingRight?: boolean;
};

export const SportBoxWithSearch = ({
  labelsBoxWithSearch,
  children,
  slug,
  // onSecondaryFilterSelected,
  isActive = true,
  noPaddingRight,
}: SportBoxWithSearchProps) => {
  const dispatch = useAppDispatch();
  const { isMobile } = useWindowSize();
  const { boxSearchTipiScommessa } = useSelector((root: RootState) => root.sport);
  const { debouncedValue } = useDebounce(boxSearchTipiScommessa.textSearched!, SEARCH_DELAY);

  const { getSearchData, currentData } = useSportSearchTipiScommessa(
    boxSearchTipiScommessa.indexFilter,
    slug!,
    debouncedValue ?? ''
  );

  return (
    <Wrapper
      bgColorTransparent
      noPaddingTop
      noPaddingBottom
      noPaddingLeft
      noPaddingRight={noPaddingRight}
      classNameWrapper={styles.wrapper}
    >
      <section
        className={`${styles.container} 
      `}
      >
        {!isMobile && (
          <div className={styles.titleContainer}>
            <ScommesseTitle>{labelsBoxWithSearch.title}</ScommesseTitle>
            {isActive && (
              <ScommesseSearch
                expandWindow={boxSearchTipiScommessa.expandWindow}
                openBtnText={labelsBoxWithSearch.searchTitle}
                placeholder={labelsBoxWithSearch.searchPlaceholder}
                onChange={(value) => dispatch(setTextSearchedTipiScommessa(value))}
                isActive={isActive}
                labelScommesseFound={labelsBoxWithSearch.labelScommesseFound}
                numberOfScommesse={!!currentData?.length ? currentData?.length : 0}
                reset={getSearchData}
              >
                {!!currentData?.length && (
                  <ScommesseFiltersList
                    className={`${boxSearchTipiScommessa.expandWindow ? styles.resultsExpandend : ''}`}
                    items={currentData.map(({ isNew, descrizione, descrizioneTrKey }) => ({
                      isNew: isNew,
                      label: descrizione,
                      labelTrKey: descrizioneTrKey,
                    }))}
                    selectedIndex={boxSearchTipiScommessa.indexFilter}
                  />
                )}
              </ScommesseSearch>
            )}
          </div>
        )}
        {children && children}
      </section>
    </Wrapper>
  );
};
